import {
  useAvailableApps,
  useEntitlements,
  useABAC,
  MockHook,
  HeadBarConfig,
} from '@jupiterone/jupiter-web-toolkit';
import { useAnchorElState } from 'react-use-object-state';
import { useEffect, useState } from 'react';

const useAppsMenuLogic = () => {
  const { anchorEl, setAnchorEl, clearAnchorEl } = useAnchorElState(null);

  const { isAdmin } = useABAC();
  const apps = useAvailableApps();

  const { entitlementEnforce, loading } = useEntitlements();
  const [userApps, setUserApps] = useState<HeadBarConfig[]>([]);
  const [lockedApps, setLockedApps] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    const filterApps = () => {
      const tempLocked: { [key: string]: boolean } = {};
      const tempUserApps = apps.filter((app) => {
        const isEntitled = entitlementEnforce(app.featureEntitlementName);

        if (!isEntitled && isAdmin) {
          tempLocked[app.name] = true;
        }
        return isEntitled || isAdmin;
      });
      setLockedApps(tempLocked);
      setUserApps(tempUserApps);
    };
    if (!loading) {
      filterApps();
    }
  }, [loading]);

  return {
    anchorEl,
    setAnchorEl,
    clearAnchorEl,
    apps: userApps,
    lockedApps,
    loading,
  };
};

export type AppsMenuComponentProps = ReturnType<typeof useAppsMenuLogic>;
export const MOCK_APPS_MENU_PROPS: AppsMenuComponentProps = {
  anchorEl: null,
  setAnchorEl: () => MockHook.mockFunction,
  clearAnchorEl: () => MockHook.mockFunction,
  apps: [] as any,
  lockedApps: {},
  loading: false,
};
export default MockHook.useMockHook(useAppsMenuLogic, MOCK_APPS_MENU_PROPS);
